import React, { Component, createRef } from 'react';

// CSS
import '../Subscriptions/Subscription.scss';

// Helper
import { checkCookie } from '../../Helper/Cookies';
import { apiFetch } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

// Properties
const properties = require('../../properties.json');

const CHOICES = [
    { label: 'قبل الميتنج بـ 5 دقايق', value: 5 },
    { label: 'قبل الميتنج بـ 10 دقايق', value: 10 },
    { label: 'قبل الميتنج بربع ساعة (الافتراضي)', value: 15 },
    { label: 'قبل الميتنج بنص ساعة', value: 30 },
    { label: 'قبل الميتنج بساعة', value: 60 },
    { label: 'قبل الميتنج بساعتين', value: 120 },
    { label: 'قبل الميتنج بيوم', value: 1440 },
    { label: 'من غير تذكير', value: 0 },
];

// When the teacher's students get a browser notification before each live meeting (MeetingReminderService).
class MeetingReminder extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = { minutes: 15, loading: true, saving: false }

    componentDidMount() {
        document.title = properties.site_name + ' | تذكير الميتنج';
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
            return;
        }
        apiFetch('/teachers/me')
            .then(me => this.setState({ minutes: me.meetingReminderMinutes != null ? me.meetingReminderMinutes : 15, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    save = () => {
        this.setState({ saving: true });
        apiFetch('/teachers/me/meeting-reminder', { method: 'PUT', body: { minutes: this.state.minutes } })
            .then(() => {
                this.setState({ saving: false });
                this.toast.current.show({ severity: 'success', summary: 'تم بنجاح', detail: 'تم حفظ ميعاد التذكير' });
            })
            .catch(error => {
                this.setState({ saving: false });
                this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال' });
            });
    }

    render() {
        const { minutes, loading, saving } = this.state;
        return (
            <>
                <Header pageName="تذكير الميتنج" />
                <Toast ref={this.toast}></Toast>
                <div className="content" dir="rtl">
                    <div className="container">
                        <div className="card">
                            <Card title="تذكير الطلاب قبل الميتنج المباشر">
                                {!loading && (
                                    <div className="p-col-12 p-md-8 p-m-3">
                                        <p>
                                            الطالب اللي فعّل التذكيرات من صفحة "Live" في موقعك بيوصله إشعار على موبايله أو كمبيوتره
                                            قبل كل ميتنج بالوقت اللي تختاره هنا، حتى لو الموقع مقفول. لما يضغط على الإشعار بيفتح الميتنج على طول.
                                            الإشعارات ببلاش ومش بتتحسب عليك.
                                        </p>
                                        <p>
                                            التذكير بيوصل لطلاب الكورس المشتركين بس لو الميتنج تبع كورس، أو لكل طلابك لو الميتنج لكل الطلاب.
                                        </p>
                                        <div className="p-inputgroup p-mb-3">
                                            <Dropdown value={minutes} options={CHOICES} onChange={e => this.setState({ minutes: e.value })} style={{ minWidth: 260 }} />
                                            <Button label={saving ? 'جاري الحفظ...' : 'حفظ'} disabled={saving} onClick={this.save} />
                                        </div>
                                    </div>
                                )}
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default MeetingReminder;
